module.exports = __webpack_public_path__ + "static/media/menu-icon.5f52b67d.svg";